import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, AddCircleOutline, AddOutlined, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowRight, ArrowRightAltRounded, CameraAltOutlined, ExitToAppOutlined, KeyboardArrowRight, Shield } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";
import CreateCommunityPopup from "../Utils/CreateCommunityPopup";

const ProfileScreen = () => {


    return <CommunityListView />;
};
const Convert_Time_Zone = (isostring) => {
    const isoString = isostring;
    const desiredFormat = "dd MMMM yyyy, hh:mm:ss a";

    const indianTimeZone = "Asia/Kolkata";
    const zonedTime = utcToZonedTime(isoString, indianTimeZone);

    const formattedDate = format(zonedTime, desiredFormat, {
        timeZone: indianTimeZone,
    });
    return formattedDate;
};
function CommunityListView({ data }) {
    const [userProfile, setUserProfile] = useState({})
    const navigate = useNavigate();
    const fileInputRef = useRef();

    const uploadLogo = async (file) => {
        if (!file) return;

        const formData = new FormData();
        formData.append("media", file, file.name);

        const token = localStorage.getItem("token");

        const res = await fetch(`${BASE_URL}/admin/update-avatar`, {
            method: "PUT",
            headers: {
                "auth-token": token
            },
            body: formData
        });

        const data = await res.json();

        if (data.success) {
            setUserProfile(data.response)
        } else {
            alert(data.response);
        }
    };


    const getProfile = async () => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/admin/view`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setUserProfile(data.response);
        }

    };

    useEffect(() => {
        async function getUserProfile() {
            const profile_obj = localStorage.getItem("profile")
            setUserProfile(JSON.parse(profile_obj))
        }
        getUserProfile()
        getProfile()
    }, []);
    const theme = useTheme();

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')

    const handlelogout = () => {
        localStorage.removeItem("token");
        navigate("/", { replace: true });
    };


    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'}>
                <Box
                    display={"flex"}
                    justifyContent="space-between"
                    alignItems={"center"}
                    sx={{ flexWrap: 'wrap', flexDirection: 'row', gap: "10px" }}
                >
                    <Header
                        title={`My Profile`}
                        subtitle={`View or update your profile details`}
                    />



                </Box>
                <Box
                    display="flex"
                    sx={{
                        px: '20px',
                        py: '20px',
                        borderRadius: "15px",
                        background: "#ffffff08",
                        maxWidth: (isMobileScreen) ? "100%" : isTabScreen ? "60%" : "40%",

                    }}
                    flexDirection={'column'}
                >

                    <Box

                        onClick={() => {
                            fileInputRef.current.click()
                        }}
                        sx={{
                            display: 'flex', justifyContent: 'center', alignItems: 'center',
                            position: 'relative',
                            alignSelf: "flex-start",
                            overflow: "hidden",
                            cursor: 'pointer',
                            "&:hover .hoverView": {
                                opacity: 1,
                                transform: "scale(1)"
                            }
                        }}>
                        <img
                            alt="profile-user"
                            width="90px"
                            height="90px"
                            src={userProfile.Photo ? userProfile.Photo :
                                "https://firebasestorage.googleapis.com/v0/b/buzz-dev-1.appspot.com/o/profile_place_holder.png?alt=media&token=b9043b44-9d9d-4864-a597-84182db5dbbb"}
                            style={{
                                cursor: "pointer", objectFit: 'cover',
                                borderRadius: "50%",
                                border: "3px solid #ffffff10"
                            }}
                        />
                        <Box
                            className="hoverView"
                            sx={{
                                position: "absolute",
                                inset: 0,
                                bgcolor: "#000000aa",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                fontFamily: "poppins-reg",
                                borderRadius: "100px",
                                opacity: 0,
                                fontSize: "10px",
                                transform: "scale(1.1)",
                                transition: "all .2s ease"
                            }}
                        >

                            <CameraAltOutlined />

                        </Box>
                    </Box>




                    <Typography style={{
                        fontFamily: "poppins-mid",
                        fontSize: "16px",
                        color: "#ffffff",
                        marginLeft: "5px",
                        marginRight: "20px",
                        marginTop: "10px"

                    }} >
                        {userProfile.UserName}
                    </Typography>
                    <Typography style={{
                        fontFamily: "poppins-reg",
                        fontSize: "11px",
                        background: userProfile.Role ? userProfile.Role == "ADMIN" ? "#ff880010" : "#aaaaaa10" : "#aaaaaa10",
                        borderRadius: "5px",
                        paddingInline: "8px",
                        paddingBlock: "3px",
                        alignSelf: "flex-start",
                        marginTop: "3px",
                        color: userProfile.Role ? userProfile.Role == "ADMIN" ? "#ff8800" : "#ffffff90" : "#ffffff90",
                        marginLeft: "5px",
                        marginRight: "20px",
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center", gap: "3px"
                    }} >
                        <Shield style={{ fontSize: "10px", marginBottom: "1px" }} />
                        {userProfile.Role ? ` Cerkle ${userProfile.Role.substring(0, 1)}${userProfile.Role.substring(1).toLowerCase()}` : "Unknown Role"}
                    </Typography>

                    <Box sx={{ height: "1px", background: "#aaaaaa10", marginTop: "15px", marginBottom: "15px" }} />

                    <Box sx={{
                        background: "#ffffff08",
                        borderRadius: "15px",
                        flexDirection: "column",
                        display: "flex",
                        py: "10px",
                        minWidth: (isMobileScreen) ? "100px" : "250px",
                        px: "10px",
                        maxWidth: (isMobileScreen) ? "100%" : isTabScreen ? "80%" : "70%",
                    }} >
                        <Typography style={{
                            fontFamily: "poppins-reg",
                            fontSize: "12px",
                            color: "#ffffff90",
                            marginLeft: "5px",
                            marginBottom: "5px"
                        }} >

                            Email Address
                        </Typography>

                        <Typography style={{
                            fontFamily: "poppins-reg",
                            fontSize: "14px",
                            color: "#ffffff",
                            background: "#00000040",
                            borderRadius: "15px",
                            paddingBlock: "15px",
                            paddingInline: "15px"

                        }} >{userProfile.Email ? userProfile.Email : "Email not found"}
                        </Typography>


                    </Box>

                    <Box
                        onClick={() => {

                        }}
                        sx={{
                            cursor: "pointer",
                            flexDirection: "row",
                            display: "flex",
                            alignItems: "center",
                            background: "#ffffff08",
                            borderRadius: "15px",
                            mt: "10px",
                            py: "15px",
                            minWidth: (isMobileScreen) ? "100px" : "250px",
                            px: "15px",
                            maxWidth: (isMobileScreen) ? "100%" : isTabScreen ? "80%" : "70%",
                        }}>

                        <Typography style={{
                            fontFamily: "poppins-reg",
                            fontSize: "14px",
                            color: "#ffffff",
                            flex: 1, display: "flex"
                        }} >

                            Change Password
                        </Typography>

                        <KeyboardArrowRight style={{ color: "#ffffff90", fontSize: "18px" }} />

                    </Box>


                    <Box
                        onClick={handlelogout}
                        sx={{
                            cursor: "pointer",
                            flexDirection: "row",
                            display: "flex",
                            alignItems: "center",
                            background: "#ffffff08",
                            borderRadius: "15px",
                            mt: "10px",
                            py: "15px",
                            minWidth: (isMobileScreen) ? "100px" : "250px",
                            px: "15px",
                            maxWidth: (isMobileScreen) ? "100%" : isTabScreen ? "80%" : "70%",
                        }}>

                        <Typography style={{
                            fontFamily: "poppins-reg",
                            fontSize: "14px",
                            color: "#ffffff",
                            flex: 1, display: "flex"
                        }} >

                            Sign out
                        </Typography>

                        <ExitToAppOutlined style={{ color: "#ffffff90", fontSize: "18px" }} />

                    </Box>


                </Box>

                <input
                    type="file"
                    accept="image/*"
                    hidden
                    ref={fileInputRef}
                    onChange={(e) => uploadLogo(e.target.files[0])}
                />

            </Box>
        </>
    );
}

export default ProfileScreen;
